import { IJsonQueryDistrict } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoDistrictTagsManager = createGeoTagsManager<IJsonQueryDistrict>({
  jsonQueryKey: 'district',
  labelGetter: ({ geoTags, geoValue }) => geoTags.districts[geoValue.id] || 'Неизвестный микрорайон',
  id: 'geoDistrict',
});
